import SearchIcon from '@mui/icons-material/Search';
import Grid from '@mui/material/Grid';
import { useState } from 'react';
import Modal from '../_datagrid/_widgets/ShippingModal';

const ShippingSearchHeaderComponent = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Grid container className='page-header'>
      <Grid item size={{ xs: 12 }}>
        <Grid container direction={'row'}>
          <Grid item size={{ xs: 6 }} textAlign={'start'}>
            <h3>Búsqueda de envíos</h3>
          </Grid>
          <Grid item size={{ xs: 6 }} textAlign={'end'}>
            <button
              className='right openModalBtn'
              onClick={() => {
                setModalOpen(true);
              }}
            >
              <SearchIcon className='svg' />
              Buscar por número de orden
            </button>

            {modalOpen && <Modal modalOpen={modalOpen} setOpenModal={setModalOpen} />}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ShippingSearchHeaderComponent;
